/**
 * Utility to coalesce renamed fields between legacy and new unified view responses
 * Maps legacy field names to new field names
 */

// Field mapping from legacy to new unified view field names
const FIELD_MAPPINGS = {
  billing_status_state_pending_shipper_accessorials_and_unbilled_receivables_charge_total:
    'billing_status_state_pending_shipper_unbilled_total',
  billing_status_state_has_pending_shipper_accessorials_or_unbilled_receivables_charge:
    'billing_status_state_has_pending_shipper_unbilled_charge',
  billing_status_state_pause_automated_billing_evaluation_reason_code:
    'pause_automated_billing_evaluation_reason_code',
  billing_status_state_pause_automated_billing_evaluation_timestamp:
    'pause_automated_billing_evaluation_timestamp',
};

/**
 * Coalesces fields between legacy and new unified view responses
 * @param {Object} item - The data item from the API response
 * @returns {Object} - The coalesced item with unified field names
 */
export function coalesceLegacyAndNewFields(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const coalesced = { ...item };

  // Process each field mapping
  Object.entries(FIELD_MAPPINGS).forEach(([legacyField, newField]) => {
    if (legacyField in coalesced) {
      // Legacy field present - rename to new field name
      coalesced[newField] = coalesced[legacyField];
      delete coalesced[legacyField];
    }
  });

  return coalesced;
}

/**
 * Coalesces an array of items
 * @param {Array} items - Array of data items from the API response
 * @returns {Array} - Array of coalesced items
 */
/**
 * Coalesces a single field name from legacy to new
 * @param {string} field - The field name to coalesce
 * @returns {string} - The coalesced field name
 */
export function coalesceFieldName(field) {
  return FIELD_MAPPINGS[field] || field;
}

export function coalesceItems(items) {
  if (!Array.isArray(items)) {
    return items;
  }

  return items.map(coalesceLegacyAndNewFields);
}
